<template>
  <v-container fluid>
    <card class="pa-4">
      <v-row no-gutters>
        <data-table
          ref="table-hoc"
          :height-offset="252"
          :filters.sync="filters"
          :schema="filterSchema"
          :headers="headers"
          :count="count"
          :loading="isLoading"
          :items="roles"
          @fetch="loadRoles"
        >
          <template v-slot:before-filter>
            <v-btn
              v-if="$canAdd()"
              color="primary"
              depressed
              class="mr-4"
              @click="openRoleDialog"
            >
              <v-icon>mdi-plus</v-icon>
              Роль
            </v-btn>
          </template>
          <!-- eslint-disable-next-line vue/valid-v-slot -->
          <template #item.created_at="{ item: { created_at } }">
            {{ created_at }}
          </template>
          <!-- eslint-disable-next-line vue/valid-v-slot -->
          <template #item.action="{ item }">
            <action-col>
              <action-col-btn
                v-if="$canViewHistory()"
                :id="`btn-view-history-${item.id}`"
                tooltip="История изменений"
                @click="showHistory(item.id)"
              >
                mdi-history
              </action-col-btn>
              <action-col-btn
                :id="`btn-edit-${item.id}`"
                :tooltip="$canEdit() ? 'Изменить' : 'Просмотр'"
                @click="openRoleDialog(item)"
              >
                {{ $canEdit() ? "mdi-pencil-outline" : "mdi-eye-outline" }}
              </action-col-btn>
              <action-col-btn
                v-if="$canDelete()"
                :id="`btn-delete-${item.id}`"
                tooltip="Удалить"
                :disabled="!item.canDelete"
                @click="deleteRole(item.id)"
              >
                mdi-close
              </action-col-btn>
            </action-col>
          </template>
        </data-table>
      </v-row>
      <role-dialog
        v-model="roleDialog"
        :readonly="!$canEdit()"
        :permission-tree="permissionTree"
        :role-id.sync="selectedRoleId"
      />
      <history-object-modal
        v-if="$canViewHistory()"
        v-model="historyDialog"
        :item-object-id="selectedRoleId"
        scope-name="Roles"
      />
    </card>
  </v-container>
</template>
<script>
import { some } from "lodash";

import NotificationMixin from "@/mixins/NotificationMixin";
import DialogMixin from "@/mixins/DialogMixin";
import CheckPermissionMixin from "@/mixins/CheckPermissionMixin";

import EventBus from "@/utils/EventBus";
import SearchFilter from "@/components/Filters/SearchFilter";
import DatetimeRangeFilter from "@/components/Filters/DatetimeRangeFilter";
import DataTable from "@/components/DataTable.vue";

import RoleDialog from "./RoleDialog";
import HistoryObjectModal from "@/components/HistoryObjectModal.vue";

import RoleRepository from "@/api/roles";

export default {
  components: { RoleDialog, HistoryObjectModal, DataTable },
  mixins: [NotificationMixin, DialogMixin, CheckPermissionMixin],
  data: () => ({
    historyTable: "roles",
    selectedRoleId: null,
    loading: {
      pagination: false,
      permissions: false,
      delete: false
    },
    roleDialog: false,
    historyDialog: false,
    filterDialog: false,
    filters: {},
    count: 0,
    permissionTree: [],
    roles: [],
    historyFetchFn: RoleRepository.getHistoryById
  }),
  computed: {
    isLoading() {
      return some(this.loading, i => i === true);
    },
    headers() {
      return [
        { text: "ID", value: "id" },
        { text: "Название", value: "title" },
        { text: "Дата создания", value: "created_at" },
        {
          text: "Количество пользователей",
          value: "total_users",
          align: "center"
        },
        {
          text: "Действия",
          value: "action",
          sortable: false,
          align: "center"
        }
      ];
    },
    filterSchema() {
      return {
        residentData: {
          filters: {
            id: {
              component: SearchFilter,
              title: "ID",
              filterBind: {
                showMethod: false,
                maxlength: 10,
                rules: "is_integer"
              }
            },
            name: {
              component: SearchFilter,
              title: "Название",
              filterBind: { showMethod: false, maxlength: 50 }
            },
            totalUsers: {
              component: SearchFilter,
              title: "Количество пользователей",
              filterBind: {
                showMethod: false,
                maxlength: 10,
                rules: "is_integer"
              }
            },
            createdAt: {
              component: DatetimeRangeFilter,
              title: "Дата создания"
            }
          }
        }
      };
    }
  },
  created() {
    this.loadPermissions();
  },
  mounted() {
    EventBus.$on("permissionsUpdated", this.$refs["table-hoc"].fetchData);
  },
  methods: {
    async loadPermissions() {
      try {
        this.loading.permissions = true;
        const { data } = await RoleRepository.getPermissions();
        this.permissionTree = data;
      } catch (error) {
        return true;
      } finally {
        this.loading.permissions = false;
      }
    },
    async loadRoles(params) {
      try {
        this.loading.pagination = true;
        let { data } = await RoleRepository.paginateRoles(params);
        this.roles = data.roles;
        this.count = data.count;
      } catch (error) {
        return true;
      } finally {
        this.loading.pagination = false;
      }
    },
    openRoleDialog({ id }) {
      this.selectedRoleId = id;
      this.roleDialog = true;
    },
    showHistory(id) {
      this.selectedRoleId = id;
      this.historyDialog = true;
    },
    async deleteRole(id) {
      try {
        const confirm = await this.confirm(
          "Удаление роли",
          "Вы действительно хотите удалить эту роль?",
          { width: 500 }
        );
        if (confirm) {
          this.loading.delete = true;
          const { data } = await RoleRepository.deleteRole(id);
          this.$refs["table-hoc"].fetchData();
          this.sendAlert({ alert: data.alert });
        }
      } catch (error) {
        return true;
      } finally {
        this.loading.delete = false;
      }
    }
  }
};
</script>
